import { settings } from '../settings';
import Fetch from '../utils/fetch';
import { Region } from '../types/orderTypes';

export default async function markPresortedForLinehaul(
  sortRegion: Region,
  orderIds: string[]
): Promise<boolean> {
  const response = await Fetch.post({
    url: `${settings.newApiUrl}/hubsort/linehaul/presorted`,
    body: {
      sortRegion,
      orderIds,
    },
  });
  return response.ok;
}
